// (c) 2023 ABBYY Development, Inc.

const translations = {
    translation: {
        views: {
            applications: {
                recording_service: {
                    title: 'Recording Service',
                    short_title: 'RS',
                    application_list: {
                        description:
                            'The excluded list is applied before the included list. If the same item appears in both lists and both lists are toggled on, user actions are not recorded across the specified item.',
                        dialog: {
                            hint: 'Provide full file path or regular expression.',
                            example: 'For example: {{example}}'
                        }
                    },
                    redaction_list: {
                        import_from_template:
                            'Import field redaction settings from template'
                    }
                }
            }
        },
        general: {
            Add: 'Add',
            Added: 'Added',
            Back: 'Back',
            Close: 'Close',
            Cancel: 'Cancel',
            Delete: 'Delete',
            Field: 'Field',
            Item: 'Item',
            Ok: 'OK',
            Recorders: 'Recorders',
            Logo: 'Logo',
            Logs: 'Logs',
            Error: 'Error',
            Templates: 'Templates',
            Loading: 'Loading...',
            Select: 'Select',
            Start: 'Start',
            Stop: 'Stop',
            Name: 'Name',
            Host: 'Host',
            Tag: 'Tag',
            Template: 'Template',
            Status: 'Status',
            Save: 'Save',
            Saved: 'Saved',
            Computer: 'Computer',
            Log: 'Log',
            Username: 'Username',
            Password: 'Password',
            NotFound: 'Not found',
            Remove: 'Remove',
            Filter: 'Filter',
            Cached: 'Cached',
            Id: 'Id',
            Role: 'Role',
            Open: 'Open',
            Dismiss: 'Dismiss',
            Acknowledge: 'Acknowledge',
            Next: 'Next',
            Prev: 'Prev',
            Screenshot: 'Screenshot',
            Settings: 'Settings',
            Submit: 'Submit',
            Yesterday: 'Yesterday',
            Time: 'Time',
            Date: 'Date',
            Yes: 'Yes',
            Min: 'Min',
            Max: 'Max',
            new_template: 'New Template',
            Create: 'Create',
            clear_all: 'Clear all',
            Transformations: 'Transformations',
            transformation_pattern: 'Regular expression',
            transformation_replacement: 'Replacement',
            transformation_case_insensitive: 'Case insensitive',
            About: 'About',
            Authors: 'Authors',
            Version: 'Version',
            ImageProcessingVersion: 'Image processing version',
            Edit: 'Edit',
            In_progress: 'In progress',
            Application: 'Application',
            Element_type: 'Element type',
            Timestamp: 'Timestamp',
            uploading: 'uploading',
            from: 'From',
            to: 'To',
            user_name: 'Username',
            connect_to_timeline: 'Connect to your Timeline account',
            connect: 'Connect',
            revoke_access: 'Revoke access',
            not_logged_in:
                'Recording Service needs your permissions to upload logs to Timeline',
            not_connected_to_timeline:
                'Missing upload permission. Connect to Timeline and grant permissions.',
            connected_to_timeline: 'Connected as {{ email }}',
            General: 'General',
            Export: 'Export',
            Agents: 'Agents',
            Compatible: 'Compatible'
        },
        error: {
            could_not_remove_recorders:
                'The following recorders could not be removed: {{ list }}',
            could_not_save_template:
                'An error occurred when saving the template: "{{templateName}}". Please try again later',
            could_not_delete_template:
                'Couldn\'t delete the template: "{{templateName}}". Please try again later',
            internal_server_error: {
                large_text: 'Internal Server Error',
                small_text:
                    'It seems our servers are down for maintenance, please try again later'
            },
            forbidden_error: {
                large_text: 'Access forbidden',
                small_text:
                    "It seems you don't have sufficient permissions to view this page"
            },
            general_error: {
                large_text: 'Request failed with status code'
            },
            not_found_error: {
                large_text: 'The requested resource could not be found'
            },
            could_not_save_timeline_connection: {
                UnknownError:
                    'There was an error saving the timeline connection details. Please try again later',
                BadUrl: 'The provided URL is not valid. Please use a valid URL and try again',
                ServerUnreachable:
                    'The server could not be reached, please notify the administrators and try again later',
                ServerError:
                    'Server error, please notify the administrators and try again later',
                SslError:
                    'SSL certificate error, please notify the administrators and try again later'
            },
            invalid_value: 'Invalid value.',
            could_not_upload_timeline: {
                too_large_request:
                    'Your Timeline upload failed because the logs contained too many unique events. To resolve this issue, try reducing the number of events. To resolve all issues, log in to Timeline and delete all data from the project'
            },
            RegexParseException:
                'There was an error saving the Transformation. Please try again using a valid pattern.',
            RegexTimeoutException:
                'Processing this pattern would take too much time. Please try again using a different one.',
            UnknownException:
                'There was an error saving the Transformation. Please try again using a valid pattern.',
            upload_not_cancellable: 'Upload cannot be canceled',
            transformation_not_cancellable: 'Transformation cannot be canceled',
            deletion_not_cancellable: 'Deletion cannot be canceled',
            something_happened: 'An error occurred. Please try again later.',
            invalid_base_url:
                'The Recording Service public URL is not valid. Please use a valid URL and try again',
            from_to_same: 'The "From" and "To" values cannot be the same'
        },
        status_codes: {
            '503': {
                message: 'Service Unavailable',
                detailed_message:
                    'The server is not able to handle the request at the moment. Please try again later'
            },
            '500': {
                message: 'Internal server error',
                detailed_message:
                    'Server error, please notify the administrators and try again later'
            },
            '409': {
                message: 'Conflict',
                detailed_message:
                    'Server validation failed. The request could not be completed due to a conflict with the current state of the resource.'
            },
            '403': {
                message: 'Forbidden',
                detailed_message: 'Insufficient permissions'
            },
            '404': {
                message: 'Not found',
                detailed_message: 'Resource not found'
            },
            '401': {
                message: 'Unauthorized',
                detailed_message:
                    "It seems you don't have enough permissions to access this page or your credentials are invalid"
            },
            '400': {
                message: 'Bad Request',
                detailed_message:
                    'The server cannot process the request due to a client error'
            },
            '201': {
                message: 'Created',
                detailed_message: 'The request has been completed'
            },
            '0': {
                message: 'Something wrong',
                detailed_message: 'Something went wrong'
            }
        },
        success: {
            all_recorders_removed:
                'Successfully removed all selected recorders',
            all_recorder_logs_removed:
                'Successfully removed all logs for the selected recorders',
            recorders_removed:
                'Successfully removed the following recorders: {{ list }}',
            recorders_status_changed:
                'It would take approximately 10 seconds to update the state. Please refresh the list to see the changes.'
        },
        expressions: {
            not_found: 'not found',
            save_template: 'Save template',
            template_saved: 'Template "{{name}}" saved',
            delete_recorders: 'Delete recorders',
            delete_recorder_logs: 'Delete recorder logs',
            delete_offline_recorders: 'Delete offline recorders',
            delete_template: 'Delete template',
            delete_templates: 'Delete templates',
            delete_template_success:
                '"{{name}}" template was successfully deleted',
            delete_template_failed: '',
            template_name: 'Template name',
            max_record_duration_min: 'Max record duration, minutes',
            record_on_assignment: 'Record on assignment',
            start_recording_when_assigned_to_recorder:
                'Start recording when assigned to recorder',
            record_extended_element_data: 'Record extended application info',
            application_list: 'Application list',
            field_redaction: 'Field redaction',
            whitelist: 'Included list',
            blacklist: 'Excluded list',
            add_template: 'Add template',
            add_template_success: '{{name}} added',
            delete_templates_success: 'Deleted templates: {{deletedTemplates}}',
            delete_templates_failed: 'Failed to delete the following templates',
            delete_selected: 'Delete selected',
            obfuscate_user_data: 'Obfuscate user data',
            turn_off: 'Turn off',
            turn_on: 'Turn on',
            set_template: 'Set template',
            set_tag: 'Set tag',
            refresh_list: 'Refresh list',
            last_seen: 'Last seen',
            events_parenthesis_thousands: 'Events (thousands)',
            log_id: 'Log id',
            recording_start: 'Recording start',
            duration_parenthesis_minutes: 'Duration (minutes)',
            duration: 'Duration',
            disk_space_parenthesis_mb: 'Disk space (MB)',
            processing_percent: 'Processing (%)',
            last_project: 'Last project',
            download: 'Download',
            load_to_project: 'Load to project',
            recorded_events: 'Recorded events',
            events: 'Events',
            apps: 'Apps',
            forms: 'Forms',
            unique_events: 'Unique events',
            disk_space: 'Disk space',
            add_item_to_whitelist: 'Add item to included list',
            add_item_to_blacklist: 'Add item to excluded list',
            add_item: 'Add item',
            edit_item: 'Edit item',
            recorders_count: 'Recorders count',
            missing_credentials: 'Missing credentials',
            missing_state_or_code: 'Missing state or code parameter',
            select_template_for_recorders: 'Select template for recorders',
            change_tag_of_recorders: 'Change tag of recorders',
            no_ongoing_or_completed_processes:
                'No ongoing or completed processes',
            delete_log_success: 'Log deleted {{id}}',
            delete_log_failed: 'Failed to delete log: {{id}}',
            delete_logs_success: 'Logs deleted',
            delete_logs_failed: 'Failed to delete the following logs',
            uploading_logs: 'Uploading logs',
            uploading_screenshots: 'Uploading screenshots',
            transforming_logs: 'Transforming log(s) {{logList}}',
            transforming_logs_all: 'Transforming selected logs',
            uploading_logs_success:
                'The following logs were successfully imported into project <0>"{{projectName}}"</0>: {{logList}}.',
            transformation_success:
                'Transformation completed for the following logs: {{logList}}',
            transformation_success_all:
                'Transformation completed for selected logs',
            uploading_logs_failed:
                'Failed to import log(s) {{logList}} into the project "{{projectName}}"',
            transformation_failed: 'Failed to transform log(s) {{logList}}',
            transformation_failed_all: 'Failed to transform selected logs',
            transformation_cancelled:
                'Transformation was canceled for the following logs: {{logList}}',
            transformation_cancelled_all: 'Transformation was canceled',
            uploading_logs_cancelled:
                'Upload into project was canceled for the following logs: {{logList}}',
            size_in_megabytes: 'Size in Megabytes',
            logs_count: 'Logs count',
            project_list: 'Project List',
            select_project: 'SELECT PROJECT',
            create_project: 'CREATE PROJECT',
            no_desktop_enabled_project_text:
                'It seems you do not have a project with Task Mining enabled yet. Logs can only be uploaded into a Timeline project that has task mining enabled. You can create your first Task Mining project right now. Once it is created, logs will automatically be exported into it.',
            sort_after_Ascending: 'Sort by descending',
            sort_after_Descending: 'Cancel sorting',
            sort_after_None: 'Sort by ascending',
            timeline_url: 'Timeline URL',
            app_url: 'Recording Service public URL',
            app_url_info:
                'Recording Service should be accessible to the user at this URL, the use of hostnames is preferred over localhost.',
            import_queued: 'Import Queued',
            importing_logs: 'Importing Logs',
            importing_success: 'Import Successful',
            importing_failed: 'Importing Failed',
            uploading_logs_queued:
                'The following logs were queued to upload into the project "{{projectName}}": {{logList}}',
            transformation_queued:
                'The following logs were queued for transformation: {{logList}}',
            transformation_queued_all:
                'All logs were queued for transformation',
            obfuscation_queued: 'Log {{id}} was queued for obfuscation',
            obfuscation_pre_processing:
                'Preprocessing the log {{id}} for obfuscation',
            obfuscation_processing: 'Log {{id}} obfuscation is in progress',
            obfuscation_finished: 'Log {{id}} was successfully obfuscated',
            obfuscation_failed: 'Failed to obfuscate log {{id}}',
            status_of_uploading_logs_updated:
                'Received progress message for your ongoing job',
            project_name: 'Project name',
            uploading_logs_process:
                'Importing log(s) {{logList}} into the project "{{projectName}}"',
            deletion_success: 'Successfully deleted log(s): {{logList}}',
            deleting_logs: 'Deleting log(s): {{logList}}',
            deletion_cancelled:
                'Deletion canceled for the following log(s): {{logList}}',
            deletion_queued:
                'The following log(s) were queued to be deleted: {{logList}}',
            everything_broken:
                'Critical error, please contact an administrator.',
            show_message: 'Show message',
            delete_logs: 'Delete logs',
            delete_log: 'Delete log',
            cannot_be_empty: 'Cannot be empty',
            project_name_taken:
                'This project name is taken, please choose another.',
            invalid_name_length:
                'Name field cannot be empty or exceed 200 characters',
            cannot_be_duplicate: 'This item already exists',
            x_minutes: '{{minutes}} minutes',
            save_connection: 'Save',
            reset_connection: 'Reset',
            name_of_connection: 'Name of the connection',
            client_id: 'Client ID',
            client_secret: 'Client secret',
            oauth_nav_message:
                'You will be redirected to Timeline authentication',
            image_not_found: 'Image not found',
            start_date: 'Start date',
            end_date: 'End date',
            last_seven_days: 'Last 7 days',
            last_thirty_days: 'Last 30 days',
            this_month: 'This month',
            last_month: 'Last month',
            reset_filter: 'Reset',
            timeline_connection: 'Timeline Authentication',
            log_upload_limit_message:
                'The selected logs contain over 20Gb of data. Some screenshots will not be uploaded. Proceed?',
            timeline_connection_guide: {
                title: 'Timeline Authentication Guide',
                content: {
                    line_1: `<strong>TimelineURL</strong> should be the URI of your installed Timeline instance. If you haven't installed Timeline yet, please do so now.`,
                    line_2: {
                        main: 'In your running Timeline instance, create an account and after logging in',
                        a: 'Navigate to Account Settings → OAuth → and click on "Register client"',
                        b: {
                            main: 'Fill out the client registration form',
                            i: '<strong>App name</strong> can be anything',
                            ii: {
                                1: '<strong>App URL</strong>',
                                2: 'Click on the icon to copy this value and paste it to the client registration form in Timeline'
                            },
                            iii: {
                                1: '<strong>Redirect URI</strong>',
                                2: 'Click on the icon to copy this value and paste it to the client registration form in Timeline'
                            },
                            iv: 'You can upload an optional Client Logo',
                            v: 'Make sure to check the <code>Confidential client</code> checkbox',
                            vi: 'Make sure to only check the <code>Read projects</code> and <code>Write projects</code> checkboxes',
                            vii: 'Click "Register client"'
                        },
                        c: 'Copy the values of <code>Client ID</code> and <code>Client secret</code> respectively to this screen'
                    },
                    line_3: 'Click "Save"'
                }
            },
            upload_error_ScreenshotSizeExceeded:
                'Screenshot size exceeded the maximum size limit for the selected logs. Some screenshots will not be uploaded.',
            upload_error_UniqueEventNumberExceeded:
                'The number of unique events in the selected logs exceeds the allowed limit. You cannot proceed with the upload.',
            upload_error_EventNameLengthExceeded:
                'Exceeded the event name length limit for the selected logs. You cannot proceed with the upload.',
            upload_error_NoLogsFound:
                'No logs found. You cannot proceed with the upload.',
            upload_error_UnsupportedLogVersion:
                'This version is not supported.',
            confirm_navigation_title: 'Confirm navigation',
            confirm_navigation_body_1: 'You have unsaved changes.',
            confirm_navigation_body_2:
                'If you click "OK", your changes will be lost.',
            confirm_navigation_body_3: 'Proceed without saving changes?',
            create_transformation: 'Add transformation',
            edit_transformation: 'Edit transformation',
            not_valid_regex: 'Not a valid regular expression.',
            apply_transformation: 'Apply transformation',
            apply_to_all_logs: 'Apply to all logs',
            apply_to_selected_logs: 'Apply to selected logs',
            delete_transformations: 'Delete transformations',
            delete_transformation: 'Delete transformation',
            add_transformation_success: 'Transformation added',
            edit_transformation_success: 'Transformation edited',
            apply_transformations_success:
                'Transformations were applied successfully',
            delete_transformations_success:
                'Transformations were deleted successfully',
            delete_transformations_failed:
                'An error occurred while deleting transformations',
            must_be_number: 'Must be a number.',
            about_modal_title: 'About ABBYY Recording Service',
            base_url_copied: 'Base URL copied to clipboard',
            callback_url_copied: 'Redirect URL copied to clipboard',
            legal_text: 'ABBYY Development Inc',
            to_create_transformation:
                'To create or update a transformation, go to ',
            this_page: 'this page.',
            no_transformations:
                'There are no transformations. To create one, go to <0>this page</0>.',
            assign_transformation: 'Add transformation to the template',
            tag_change_success: 'Tags changed successfully',
            recorder_template_change_success: 'Template changed successfully',
            outdated_recorder:
                'This recorder is not compatible with the current Recording Service version and should be updated',
            language: 'Language',
            server_settings: 'Logs',
            obfuscate_on_export: 'Obfuscate user data',
            change_language: 'Change Language',
            scheduled_recording: 'Scheduled recording',
            copy_instructions: 'Copy to clipboard: Ctrl+C, Enter',
            merge_hosts: 'Merge data from multiple hosts',
            processing: 'Processing: {{value}}%',
            processed: 'Processed',
            total_values: 'TOTAL\nVALUES',
            unique_values: 'UNIQUE\nVALUES',
            log_version_mismatch:
                'Selected logs are not compatible and cannot be uploaded together',
            compatible_projects: 'List of projects compatible with logs format',
            missing_forms: `There are no forms detected yet. Possibly, a recording session is in progress or forms are still being detected, it can take some time. Still, you can upload logs to Timeline, if the log status is processed, the forms for the processed part of the log will be calculated there.`,
            cant_upload_logs_without_screenshots:
                "Can't upload logs without screenshots",
            cant_upload_old_log_version:
                'Logs under version 5.3 and earlier are no longer supported for upload to Timeline.',
            blocked_recording:
                'Screenshot missing because recording user activity is not allowed in this application.',
            disclose_operator: 'Show username on the Logs tab',
            export_operator: 'Include username',
            export_host: 'Include computer name',
            agent_id: 'Agent ID',
            no_form_found: 'No form found'
        },
        delete_modal: {
            delete_item:
                'Are you sure you wish to permanently delete this item?',
            delete_recorder_logs:
                'Are you sure you wish to permanently delete the logs for the selected recorders?',
            delete_items:
                'Are you sure you wish to permanently delete these items?',
            warning_recorder_online:
                'Online recorders cannot be deleted. This will only delete the offline recorders. Please stop them before trying to remove them again.'
        },
        obfuscate_modal: {
            text1: 'This operation modifies the selected log by blurring out sensitive user information. This action is not reversible and may take a long time.',
            text2: 'Are you sure you want to obfuscate the log?'
        },
        obfuscation_response: {
            CannotFindTemplate:
                'Unable to find template for session, possible database corruption.',
            RedactionPolicyAlreadyEnabled: 'Obfuscation is already enabled.',
            SessionIsActive:
                'Session is still active. Stop the recorder and try again later.',
            ProcessingInProgress:
                'Previous processing has not been finished, try again later.'
        },
        status: {
            online: 'online',
            offline: 'offline',
            recording: 'recording',
            unhealthy: 'unhealthy'
        },
        filter_options: {
            Online: 'Online',
            Offline: 'Offline',
            Recording: 'Recording',
            true: 'Enabled',
            false: 'Disabled'
        },
        oauth_error:
            'There was an error loading your Timeline projects. Please contact your system administrator. Error code: "{{errorCode}}"',
        invalid_clint_secret:
            'Your Timeline connection has been terminated because Recording Service could not authenticate to Timeline. Verify the authentication setting for the Timeline and then try connecting again. If the problem persists, contact your network administrator.',
        languages: {
            'en-US': 'English',
            'ja-JP': 'Japanese'
        },
        project_roles: {
            DASHBOARD_VIEWER: 'DASHBOARD VIEWER',
            VIEWER: 'VIEWER',
            USER: 'USER',
            DATA_MASTER: 'DATA MANAGER',
            ADMIN: 'ADMIN',
            OWNER: 'OWNER'
        }
    }
};

export default translations;
